import { Observable } from 'rxjs';

import { UseCase } from '../../base/use-case';

import { AcademyRepository } from '../../repositories/academy.repository';
import { ContentAcademyModel, DataContentAcademyModel } from '../../models/academy/content-academy.model';

export class InsertContentAcademyUseCase implements UseCase<
  DataContentAcademyModel,
  ContentAcademyModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(
    params: DataContentAcademyModel,
  ): Observable<ContentAcademyModel> {
    return this.repository.insertContentAcademy(params);
  }
}
